import { render, staticRenderFns } from "./PagibigEmployeeContribution.vue?vue&type=template&id=2288a116"
import script from "./PagibigEmployeeContribution.vue?vue&type=script&lang=js"
export * from "./PagibigEmployeeContribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports